const cliplisterScriptID = 'cliplister-script';

export const addCliplisterScript = (scriptUrl: string) =>
  new Promise<void>((resolve, reject) => {
    const cliplisterScript = document.getElementById(cliplisterScriptID);
    if (!cliplisterScript) {
      const script = document.createElement('script');
      script.onload = () => resolve();
      script.onerror = reject;
      script.setAttribute('src', scriptUrl);
      script.setAttribute('id', cliplisterScriptID);
      document.head.insertBefore(script, document.head.firstElementChild);
    } else {
      resolve();
    }
  });
